export default function About() {
  return (
    <section id="about" className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="inline-block px-4 py-2 bg-[#E3F2FD] rounded-lg mb-6">
              <span className="text-xs font-semibold text-[#002B5C] uppercase tracking-wide">
                EST. 2020 | GLOBAL PRESENCE
              </span>
            </div>
            <h2 className="text-5xl font-bold text-[#002B5C] mb-8 leading-tight">
              Advancing Scientific Innovation Across Three Continents
            </h2>
            <p className="text-lg text-[#6B7280] leading-relaxed">
              Headquartered in San Juan, PR with operational centers in USA, Germany, and China
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-gradient-to-br from-[#FFC107] to-[#FF8F00] rounded-[32px] p-12 relative overflow-hidden">
              <div className="absolute top-8 left-12">
                <span className="text-xs text-white/70 font-medium uppercase tracking-wider">
                  OUR MISSION
                </span>
              </div>
              <div className="absolute top-8 right-12">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-more-fill text-white text-xl"></i>
                </div>
              </div>
              <div className="mt-16 mb-16">
                <p className="text-3xl text-white leading-relaxed font-light">
                  We bridge the gap between cutting-edge research and practical application, delivering FDA-compliant solutions that empower the global scientific community
                </p>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-white/20 overflow-hidden">
                    <img
                      src="https://public.readdy.ai/ai/img_res/3a206fc9f9cd80faddd797052556f55b.jpg"
                      alt="CEO"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="text-sm text-white font-medium">Dr. Maria Santos, CEO</span>
                </div>
                <button className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                  <i className="ri-arrow-right-line text-white text-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}